// Auth utilities backed by a secure cookie (tc_token) and Redux store.

import Cookies from "js-cookie";
import { TOKEN_COOKIE_NAME } from "../store/authSlice";

export function getToken() {
  return Cookies.get(TOKEN_COOKIE_NAME) || null;
}

export function isAuthenticated() {
  return !!getToken();
}

// Kept in memory only — never persisted to localStorage. The profile it
// holds (name, email, roles, tenant IDs) is PII; localStorage survives
// page reloads and is trivially readable by any XSS payload, so it must
// not be a durable store for it. Resets on full page reload, matching
// the existing login/session-restore flows that call setCurrentUser again.
let currentUser = null;

export function getCurrentUser() {
  return currentUser;
}

export function setCurrentUser(user) {
  currentUser = user || null;
}

export function logout() {
  setCurrentUser(null);
  Cookies.remove(TOKEN_COOKIE_NAME);
}
